import {
	Component,
	OnInit,
	Input,
	ViewEncapsulation,
	forwardRef,
	EventEmitter,
	Output,
	ViewChild,
} from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { DATE_PICKER_RANGE_FUTURE, DATE_PICKER_RANGE_PAST } from 'src/app/core/constants/constants';


import dayjs from 'dayjs';
import { Dayjs } from 'dayjs';


export interface Date_range {
	dateStart: Dayjs;
	dateEnd: Dayjs;
}

@Component({
	selector: 'app-form-range-date',
	templateUrl: './form-range-date.component.html',
	styleUrls: ['./form-range-date.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FormRangeDateComponent),
			multi: true,
		},
	],
})
export class FormRangeDateComponent implements ControlValueAccessor, OnInit {
	@Input() labelTitle: string = '';
	@Input() position: string = 'right';
	@Input() placeholder: string = 'Select date please...';
	@Input() range_type: string = '';
	@Input() autoApply: boolean = false;
	@Output() OnSelected: EventEmitter<Date_range> = new EventEmitter();

	@ViewChild(DaterangepickerDirective, { static: false })
	pickerDirective?: DaterangepickerDirective;

	// selected: {startDate: dayjs.Dayjs, endDate: dayjs.Dayjs};
	selected: { startDate: moment.Moment; endDate: moment.Moment }; //inicializa date to have on control
	backDate?: Date_range; //var to return
	start = moment();
	end = moment();

	alwaysShowCalendars: boolean = false;

	onChange: (value: Date_range) => void = (value: Date_range) => {};
	onTouch: any = () => {};

	ranges: any = {
		Today: [
			dayjs(new Date()).format('YYYY-MM-DD'),
			dayjs(new Date()).format('YYYY-MM-DD'),
		],
		Yesterday: [
			dayjs().subtract(1, 'days').format('YYYY-MM-DD'),
			dayjs().subtract(1, 'days').format('YYYY-MM-DD'),
		],
		'This week': [
			dayjs().day(0).format('YYYY-MM-DD'),
			dayjs().day(6).format('YYYY-MM-DD'),
		],
		'Last Week': [
			dayjs().day(0).subtract(7, 'days').format('YYYY-MM-DD'),
			dayjs().day(6).subtract(7, 'days').format('YYYY-MM-DD'),
		],
		'Next Week': [
			dayjs().day(0).add(7, 'days').format('YYYY-MM-DD'),
			dayjs().day(6).add(7, 'days').format('YYYY-MM-DD'),
		],
		'This month': [
			dayjs().startOf('month').format('YYYY-MM-DD'),
			dayjs().endOf('month').format('YYYY-MM-DD'),
		],
		'Last month': [
			dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
			dayjs().format('YYYY-MM-DD'),
		],
		'Past 2 months': [
			dayjs().subtract(2, 'month').format('YYYY-MM-DD'),
			dayjs().format('YYYY-MM-DD'),
		],
		'Past 3 months': [
			dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
			dayjs().format('YYYY-MM-DD'),
		],
		'Current year': [
			dayjs().startOf('year').subtract(0, 'year').format('YYYY-MM-DD'),
			dayjs(new Date()).format('YYYY-MM-DD'),
		],
		'Last year': [
			dayjs().startOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
			dayjs().endOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
		],
	};

	options: any = {
		format: 'YYYY-MM-DD',
		separator: ' - ',
		displayFormat: 'DD MMMM YYYY',
		cancelLabel: 'CANCEL',
		applyLabel: 'APPLY',
		direction: 'ltr',
	}; //direction 'ltr' or 'rtr'

	constructor() {
		var momentStart = moment();
		var momenEnd = moment();

		this.selected = {
			startDate: momentStart,
			endDate: momenEnd,
		};
	}
	ngOnInit(): void {
		if(this.range_type != ''){
			switch (this.range_type) {
				case 'RANGE_PAST':
					this.ranges = DATE_PICKER_RANGE_PAST;
					break;
				case 'RANGE_FUTURE':
					this.ranges = DATE_PICKER_RANGE_FUTURE;
					break;

				default:
					break;
			}
		}
	}

	choosedDate(date: any) {
		if (date.startDate != null && date.endDate != null) {
			var f_date_start = new Date(
				date.startDate.year(),
				date.startDate.month(),
				date.startDate.date(),
			);
			var date_start: dayjs.Dayjs = dayjs(f_date_start);
			var f_date_end = new Date(
				date.endDate.year(),
				date.endDate.month(),
				date.endDate.date(),
			);
			var date_end: dayjs.Dayjs = dayjs(f_date_end);

			this.backDate = { dateStart: date_start, dateEnd: date_end };

			this.onChange(this.backDate);
			this.OnSelected.emit(this.backDate);
		} else {
			this.backDate = {
				dateStart: dayjs(new Date()),
				dateEnd: dayjs(new Date()),
			};
		}
	}
	rangeChanged(date: any) {
		if (date != null && date != null) {
			if (date.dates.length > 0) {
				var f_date_start = new Date(
					date.dates[0].year(),
					date.dates[0].month(),
					date.dates[0].date(),
				);
				var date_start: dayjs.Dayjs = dayjs(f_date_start);
				var f_date_end = new Date(
					date.dates[1].year(),
					date.dates[1].month(),
					date.dates[1].date(),
				);
				var date_end: dayjs.Dayjs = dayjs(f_date_end);

				this.backDate = { dateStart: date_start, dateEnd: date_end };
			} else {
				this.backDate = {
					dateStart: dayjs(new Date()),
					dateEnd: dayjs(new Date()),
				};
			}
		} else {
			this.backDate = {
				dateStart: dayjs(new Date()),
				dateEnd: dayjs(new Date()),
			};
		}
		this.onChange(this.backDate);
	}

	writeValue(value: Date_range): void {
		var momentStart = moment();
		var momenEnd = moment();

		if (value != null || value != undefined) {
			momentStart = moment([
				value.dateStart.year(),
				value.dateStart.month(),
				value.dateStart.date(),
			]);
			momenEnd = moment([
				value.dateEnd.year(),
				value.dateEnd.month(),
				value.dateEnd.date(),
			]);
			this.selected.startDate = momentStart;
			this.selected.endDate = momenEnd;
		} else {
			this.selected;
			this.selected = {
				startDate: momentStart,
				endDate: momenEnd,
			};
		}
	}
	registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	registerOnTouched(fn: any): void {}
	setDisabledState?(isDisabled: boolean): void {}
}
